import useResident from 'hooks/useResident'
import { Navigate, useParams } from 'react-router-dom'
import GPContactForm from '../forms/GPContactForm'

const GPContactScreen = () => {
  const { id } = useParams()

  if (!id) {
    return <Navigate to="/residents" />
  }

  const { isLoading, resident, updateResident } = useResident({ id })

  return (
    <GPContactForm
      onSubmit={updateResident}
      isLoading={isLoading}
      resident={resident}
    />
  )
}

export default GPContactScreen
